<template>
  <div class="stepper-footer">
    <v-divider />
    <div
      class="stepper-footer__buttons d-flex flex-column
      flex-md-row justify-end pt-5 pb-6 px-2 ga-2"
      :class="{'is-responsive': $vuetify.display.mobile}"
    >
      <slot>
        <slot
          name="custom"
        />
        <form-btn
          v-if="displayCancelBtn"
          class="stepper-footer__cancel"
          data-kp-anchor="common.stepper-footer.cancel-button"
          :loading="computedLoading"
          :to="cancelRoute"
          data-cy="stepper-footer__buttons-cancel"
          @click="cancel()"
        >
          {{ cancelBtnText }}
        </form-btn>
        <form-btn
          v-if="displayPreviousBtn"
          class="stepper-footer__previous"
          data-kp-anchor="common.stepper-footer.previous-button"
          :disabled="disablePreviousBtn"
          :loading="computedLoading"
          data-cy="stepper-footer__buttons-previous"
          @click="previousStep()"
        >
          {{ $t('common.previous') }}
        </form-btn>
        <form-btn
          v-if="nextStepBtn"
          class="stepper-footer__next"
          data-kp-anchor="common.stepper-footer.next-button"
          :loading="computedLoading"
          data-cy="stepper-footer__buttons-next"
          @click="nextStep()"
        >
          {{ $t('common.next') }}
        </form-btn>
        <form-btn
          v-if="addBtn"
          class="stepper-footer__add"
          data-kp-anchor="common.stepper-footer.add-button"
          data-cy="stepper-footer__buttons-validate"
          :disabled="disableValidateBtn"
          :loading="computedLoading"
          @click="add()"
        >
          {{ addLabel ? addLabel : $t('common.add') }}
        </form-btn>
        <form-btn
          v-if="updateBtn"
          class="stepper-footer__validate"
          data-kp-anchor="common.stepper-footer.update-button"
          data-cy="stepper-footer__buttons-validate"
          :loading="computedLoading"
          :disabled="disableValidateBtn"
          @click="update()"
        >
          {{ $t('common.save') }}
        </form-btn>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepperFooter',
  props: {
    /**
     * Component is loading
     */
    loading: {
      type: [Boolean, Number],
      default: false,
    },
    disablePreviousBtn: {
      type: Boolean,
      default: true,
    },
    nextStepBtn: {
      type: Boolean,
      default: false,
    },
    addBtn: {
      type: Boolean,
      default: true,
    },
    updateBtn: {
      type: Boolean,
      default: false,
    },
    displayPreviousBtn: {
      type: Boolean,
      default: true,
    },
    displayDeleteBtn: {
      type: Boolean,
      default: false,
    },
    disableDeleteBtn: {
      type: Boolean,
      default: false,
    },
    displayDisableBtn: {
      type: Boolean,
      default: false,
    },
    /**
     * Label to display for the Add btn
     */
    addLabel: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Set the redirection onclick the cancel button
     * {name: 'Name'}
     * {path: Path}
     */
    cancelRoute: {
      type: Object,
      default: undefined,
    },
    displayCancelBtn: {
      type: Boolean,
      default: true,
    },
    disableValidateBtn: {
      type: Boolean,
      default: false,
    },
    labelCancel: {
      type: String,
      default: null,
    },
  },
  emits: ['delete', 'nextStep', 'previousStep', 'cancel', 'add', 'update', 'disable'],
  computed: {
    cancelBtnText() {
      return (this.labelCancel) ? this.labelCancel : this.$t('common.cancel');
    },
    computedLoading() {
      if (typeof this.loading === 'boolean') return this.loading;
      return this.loading > 0;
    },
  },
  methods: {
    nextStep() {
      this.$emit('nextStep');
    },
    previousStep() {
      this.$emit('previousStep');
    },
    cancel() {
      this.$emit('cancel');
    },
    add() {
      this.$emit('add');
    },
    update() {
      this.$emit('update');
    },
    disable() {
      this.$emit('disable');
    },
  },
};
</script>
<style lang="scss">
.stepper-footer {
  &__buttons {
    > .v-btn {
      // Countering Vuetify default styles
      margin-inline-start: 0 !important;
    }
  }
}
</style>
